import { createTheme, type PaletteMode } from "@mui/material";
import { palettes } from "./palette";

const fontFamily = '"Space Grotesk", sans-serif';
const monoFontFamily = '"JetBrains Mono", monospace';

export { monoFontFamily };

export const createAppTheme = (mode: PaletteMode) =>
  createTheme({
    palette: {
      mode,
      ...palettes[mode],
    },
    typography: {
      fontFamily,
      h1: {
        fontWeight: 700,
        fontSize: "2.25rem",
        lineHeight: 1.2,
        letterSpacing: "-0.025em",
      },
      h2: {
        fontWeight: 700,
        fontSize: "1.875rem",
        lineHeight: 1.2,
        letterSpacing: "-0.025em",
      },
      h3: {
        fontWeight: 700,
        fontSize: "1.5rem",
        lineHeight: 1.25,
        letterSpacing: "-0.02em",
      },
      h4: {
        fontWeight: 700,
        fontSize: "1.375rem",
        lineHeight: 1.3,
        letterSpacing: "-0.015em",
      },
      h5: {
        fontWeight: 600,
        fontSize: "1.125rem",
        lineHeight: 1.35,
      },
      h6: {
        fontWeight: 600,
        fontSize: "1rem",
        lineHeight: 1.4,
      },
      subtitle1: {
        fontWeight: 500,
        fontSize: "1rem",
        lineHeight: 1.5,
      },
      subtitle2: {
        fontWeight: 500,
        fontSize: "0.875rem",
        lineHeight: 1.5,
      },
      body1: {
        fontSize: "0.9375rem",
        lineHeight: 1.6,
      },
      body2: {
        fontSize: "0.8125rem",
        lineHeight: 1.5,
      },
      caption: {
        fontSize: "0.75rem",
        lineHeight: 1.5,
        letterSpacing: "0.02em",
      },
      button: {
        fontWeight: 600,
        textTransform: "none" as const,
        letterSpacing: "0.01em",
      },
      overline: {
        fontWeight: 600,
        fontSize: "0.6875rem",
        lineHeight: 2,
        letterSpacing: "0.08em",
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          "html, body, #root": {
            height: "100%",
          },
          "#root": {
            display: "flex",
            flexDirection: "column",
          },
        },
      },
    },
  });
